import React from 'react'
import { Create, useForm } from '@refinedev/antd'
import { Form, Input } from 'antd'
import type { Tables } from '@muaa/shared'

type Album = Tables<'albums'>

export function AlbumCreate() {
  const { formProps, saveButtonProps } = useForm<Album>()

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Album name is required' }]}
        >
          <Input placeholder="e.g. Homecoming 2025" />
        </Form.Item>
      </Form>
    </Create>
  )
}
